import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { UserDtoSchema } from '../contracts';

export type SetStaffTemplateAccessRequestDto = {
  id: number;
  canDownloadStaffTemplate: boolean;
};
export type SetStaffTemplateAccessResponseDto = z.infer<typeof UserDtoSchema>;

// Super-admin only — grants or revokes access to the fillable staff payroll
// import template. The plain staff export is unaffected.
export const setStaffTemplateAccess = (
  { id, canDownloadStaffTemplate }: SetStaffTemplateAccessRequestDto,
  config?: AxiosRequestConfig
) => {
  return api
    .patch(
      `/users/${id}/staff-template-access`,
      { canDownloadStaffTemplate },
      config
    )
    .then(responseContract(UserDtoSchema));
};
